import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18 8V6c0-2.2-1.8-4-4-4h-3C8.8 2 7 3.8 7 6v2c-1.044 0-1.891.802-1.982 1.822l2.498 2.498c.651.651.651 1.708 0 2.359l-2.498 2.498c.091 1.02.938 1.822 1.982 1.822h11c1.105 0 2-.895 2-2v-7c0-1.105-.895-2-2-2zm-2.793 7.5l-.707.707-2-2-2 2-.707-.707 2-2-2-2 .707-.707 2 2 2-2 .707.707-2 2 2 2zM17 8H8V6c0-1.654 1.346-3 3-3h3c1.654 0 3 1.346 3 3v2z',
    'M6.354 13.146l-3-3c-.195-.195-.512-.195-.707 0s-.195.512 0 .707l2.146 2.146H.5c-.276 0-.5.224-.5.5s.224.5.5.5h4.293l-2.146 2.146a.5003.5003 0 0 0 0 .707c.098.098.226.146.354.146s.256-.049.354-.146l3-3a.5003.5003 0 0 0 0-.707z',
  ],
  height: 20,
  width: 20,
});
